import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ProductSearchSelect from 'components/selects/ProductSearchSelect'
import CustomButton, {OutlinedButton, SecondaryButton} from 'components/CustomButton'
import { fetchProductListByIds } from 'redux/slices/notificationSlice'

const ProductSelector = ({
  type,
  products,
  setProducts,
  ext = [],
}) => {
  const [product, setProduct] = useState()
  const [isVisible, setIsVisible] = useState(false)
  const dispatch = useDispatch()

  const { product: { data: productList },
  } = useSelector((state) => state.notification)

  useEffect(() => {
    if (ext.length) {
      let ids = ext?.map((item) => item.products?.map((product) => product.id))
      if (ids.length) {
        ids = ids.reduce((acc, val) => acc.concat(val))
      }
      dispatch(fetchProductListByIds([...new Set(ids)]))
    }
  }, [ext, dispatch])

  useEffect(() => {
    if (productList.length) {
      let v = {}
      ext.forEach((element) => {
        v[element.type] = productList.filter((d) =>
          element.products.map((p) => p.id).includes(d.product_id),
        )
      })
      setProducts({
        ...v,
      })
    }
  }, [productList])

  const handleAddSelectedProducts = (type, productList) => {
    if (type === 'cart') {
      if (
        !products?.cart?.some(
          (element) => element.product_id === productList[0].product_id,
        )
      )
        setProducts({
          ...products,
          cart: [...(products?.cart ?? []), ...productList],
        })
    } else {
      if (
        !products?.wishlist?.some(
          (element) => element.product_id === productList[0].product_id,
        )
      )
        setProducts({
          ...products,
          wishlist: [...(products?.wishlist ?? []), ...productList],
        })
    }
  }

  const save = () => {
    handleAddSelectedProducts(type.value, [product])
    setProduct()
    setIsVisible(false)
  }

  return (
    <>
      <div className="flex justify-between items-center">
        <div className="text-lg font-semibold">{type.label}</div>
        <OutlinedButton onClick={() => setIsVisible(true)}>
          + Add Product
        </OutlinedButton>
      </div>
      {isVisible && (
        <div className="flex space-x-6 items-end my-4 pt-4 px-4 pb-1 bg-white rounded">
          <ProductSearchSelect
            label="Select Products"
            onChange={(v) => {
              setProduct(v)
            }}
            value={product}
          />
          <div className="flex space-x-3">
            <SecondaryButton className="mb-3.5"
              onClick={() => {
                setIsVisible(false)
                setProduct()}}
            >
              Cancel
            </SecondaryButton>
            <CustomButton
              className="mb-3.5"
              children="Add"
              disabled={!product}
              onClick={save}/>
          </div>
        </div>
      )}
    </>
  )
}

export default ProductSelector
